// extracted by mini-css-extract-plugin
export var actions = "_4t-0";
export var actionsContainer = "_4t-7";
export var border = "_4t-1";
export var childFullHeight = "_4t-e";
export var collapse = "_4t-2";
export var content = "_4t-9";
export var contentChild = "_4t-d";
export var fullscreen = "_4t-b";
export var hasLeftRadius = "_4t-j";
export var headerContainer = "_4t-3";
export var headerRow = "_4t-5";
export var hidePadding = "_4t-a";
export var navCollapsedGap = "_4t-k";
export var noScrollX = "_4t-l";
export var noScrollY = "_4t-m";
export var noTopPadding = "_4t-h";
export var optOutTopPadding = "_4t-c";
export var pageMain = "_4t-i";
export var pageOuter = "_4t-f";
export var pagePadding = "_4t-8";
export var profile = "_4t-n";
export var profileContainer = "_4t-o";
export var profileImage = "_4t-p";
export var profileMain = "_4t-q";
export var profileSubtitle = "_4t-s";
export var profileTitle = "_4t-r";
export var showLeftPadding = "_4t-g";
export var tabsPortalSlot = "_4t-6";
export var tabsWrapper = "_4t-4";
export var title = "_4t-t";